
import { useTranslation } from 'react-i18next';

const FooterReduced = ({ lang, config }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__bottom">
                    <ul className="footer__nav">
                        <li>
                            <a href={"/" + preidioma + t("contacto")}>{t("Contacto")}</a>
                        </li>
                        <li>
                            <a rel="nofollow" href={"/" + preidioma + t("cookies")}>{t("Cookies")}</a>
                        </li>
                        <li>
                            <a rel="nofollow" href={"/" + preidioma + t("politica-de-privacidad")}>{t("Política de privacidad")}</a>
                        </li>
                        <li>
                            <a href={"/" + preidioma + t("legal")}>{t("Nota legal")}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>

    );
}

export default FooterReduced;
